import Box from "../../components/Box"
import Text from "../../components/Text"

export default function PartnershipSection() {
  const features = [
    {
      number: 1,
      title: "Onboard in 10 minutes",
      description: "Share logo, colors, basic details.",
    },
    {
      number: 2,
      title: "Launch",
      description: "Your site, SEO and social posts go live automatically.",
    },
    {
      number: 3,
      title: "Grow Admissions",
      description: "The 24/7 counselor books visits and follows up.",
    },
    {
      number: 4,
      title: "See Impact",
      description: "Simple dashboards show leads, reach and ROI.",
    },
  ]

  const includedFeatures = [
    {
      column: "left",
      items: [
        "Instant website (hosting included)",
        "Local SEO pages and metadata",
        "Auto reels from your media",
        "Parents follow-ups & Reminders",
        "Priority support",
      ],
    },
    {
      column: "right",
      items: [
        "Brand kit setup (logo/colors/fonts)",
        "Daily social posts & calendars",
        "24/7 Admissions chat + booking",
        "Performance dashboards",
      ],
    },
  ]

  return (
    <Box
      leftBlock={
        <div className="flex-1 min-w-0">
          {/* <Text type="highlighter" label={"WE PROVIDE"} /> */}
          <div className="mb-8 md:text-center">
            <Text type="cardTitle" label={"A Partnership, Not a Product."} cName="text-4xl lg:text-5xl font-bold text-black leading-tight" />
            <Text type="description" label={"We serve educators with gratitude, not lock-ins. Our mission is to make your noble work unmissable."} cName="mx-auto max-w-7xl sm:mt-3 text-xs text-[#4D4D4D] text-pretty font-medium" />
          </div>

          {/* Features List */}
          <div className="space-y-3">
            {features.map((feature) => (
              <div key={feature.number} className="flex items-center gap-4">
                <div className="flex-shrink-0 w-5 h-5 bg-blue-600 rounded-full flex items-center justify-center">
                  <Text label={feature.number} cName="text-[white] font-semibold text-xs" />
                </div>
                <div>
                  <Text label={feature.title} cName="font-semibold text-gray-900 text-sm" />{" "}
                  <Text label={feature.description} cName="text-xs text-[#4D4D4D] text-pretty font-medium" />
                </div>
              </div>
            ))}
          </div>
        </div>
      }
      rightBlock={
        <div className="flex-1 min-w-0 bg-[white] rounded-xl p-4 border border-[#E2E8F1]">
          <div className="mb-8 md:text-center">
            <Text type="cardTitle" label={"What's Included (₹5,00,000 Value - Year 1)"} cName="text-xl font-bold text-[black] mb-1" />
          </div>

          {/* Two Column Feature Grid */}
          <div className="grid grid-cols-2 md:grid-cols-1 gap-8">
            {includedFeatures.map((section, index) => (
              <div key={index} className="space-y-3">
                {section.items.map((item, itemIndex) => (
                  <div key={itemIndex} className="flex items-baseline gap-3">
                    {/* <CheckCircle2 className="w-5 h-5 text-blue-600 flex-shrink-0" /> */}
                    <div className="w-2 h-2 bg-blue-600 rounded-full" />
                    <Text label={item} cName="text-gray-700 text-xs font-semibold leading-relaxed" />
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      }
    />
  )
}
